import React from "react";
import classes from "./TermsAndConditions.module.css";

function TermsAndConditions() {
  return (
    <div className="container customContainer">
      <div className="row justify-content-center">
        <div className="col-lg-auto col-12">
          <div className={`${classes.centerDiv}`}>
            <div className={classes.titleContainer}>
              <h1 className={classes.title}>puplier terms & conditions</h1>
            </div>
            <h2>Website Terms of Use</h2>
            <p>
              Please note that we are in Alfa mode and we are launching our
              functionality for the first time. This means our application and
              software might have bugs and issues yet to resolve and might
              behave in unexpected ways. If you are not sure about using our
              software under these conditions, please refrain from using the
              puplier platform.
            </p>
            <h2>1. Acceptance of Terms</h2>
            <p>
              Puplier.com (Authcite Limited) and its affiliates (“Puplier” or
              “us” or “we”) welcome you to our Site! The “Site” means our
              websites and online platform and services including
              https://www.puplier.com and any mobile or localized versions and
              related subdomains, in whatever format they may be offered now or
              in the future.
            </p>
            <ul>
              <li>
                Authcite Limited may make information, data, text, software,
                music, sound, photos, graphics, videos, messages, tags,
                interactive features or other materials (“Content”) available
                through the Site and references to “Site” include Content unless
                otherwise specified.
              </li>
              <li>
                By using or accessing any part of the Site, you are agreeing to
                these Website Terms of Use (“Terms”), our Privacy Policy and all
                other policies or notices posted by us on the Site. Portions of
                the Site may be accompanied by additional terms which apply to
                specific features or areas of the Site.
              </li>
              <li>
                Those additional terms supplement these Terms with respect to
                your use of those features or areas. These Terms may change over
                time, so whenever you visit or use this Site, you agree to the
                version of these Terms then posted. If you don’t agree to these
                Terms, don’t use the Site. Authcite Limited might change this
                Terms of use or any other policy any time depending on the need
                without prior notice.
              </li>
            </ul>
            <h2>2. Permission to Use the Site</h2>
            <ul>
              <li>You have our permission to use the Site, but only if:</li>
              <li>You are at least 16 years old;</li>
              <li>
                You are using the Site for informational and internal business
                purposes (personally or on behalf of your company); and
              </li>
              <li>
                You follow all the rules and restrictions we’ve spelled out in
                these Terms.
              </li>
            </ul>
            <h2>3. Accounts; Passwords; Security</h2>
            <ul>
              <li>
                You can set up an account in order to use parts of the Site.
                When setting up your account, you must give us accurate and
                complete information.
              </li>
              <li>
                You have complete responsibility for your account and everything
                that happens on your account. This means you need to be careful
                with your password. If you find out that someone is using your
                account without your permission, you must let us know
                immediately.
              </li>
              <li>
                You may not transfer your account to someone else or use someone
                else’s account without their permission.
              </li>
              <li>
                We are not liable for any damages or losses caused by someone
                using your account without your permission. However, if we (or
                anyone else) suffer any damage due to the unauthorized use of
                your account, you may be liable.
              </li>
            </ul>
            <h2>4. User Content</h2>
            <ul>
              <li>
                By “User Content,” we mean any Content on the puplier.com which
                includes content you are posting on the site.
              </li>
              <li>
                You are solely responsible for any User Content you post to our
                site/platform and the consequences of posting or publishing it.
              </li>
              <li>
                When we say “post”, we include posting, uploading, sharing,
                submitting or otherwise providing User Content in any manner in
                connection with the Site.
              </li>
            </ul>
            <h2>5. Restrictions on User Content and Your Conduct</h2>
            <h4>You may not:</h4>
            <ul>
              <li>
                post User Content that you don’t own or don’t have permission
                from the owner to post. This includes material covered by
                someone else’s copyright, patent, trade secret, privacy,
                publicity or any other proprietary right;
              </li>
              <li>
                post User Content that is inaccurate, fraudulent, misleading,
                illegal, obscene, defamatory, libelous, threatening,
                pornographic, harassing, hateful, racially or ethnically
                offensive, or that encourages conduct that would be considered a
                criminal offense, gives rise to civil liability, violates any
                law or is otherwise inappropriate;
              </li>
              <li>
                forge headers or manipulate other identifiers in order to
                disguise the origin of any User Content you post;
              </li>
              <li>
                upload, launch, post, email or transmit any material (including
                any bot, worm, scripting exploit or computer virus) to or from
                the Site that is likely to harm or corrupt the Site, or harm or
                corrupt our or anyone else’s computer systems or data;
              </li>
              <li>
                solicit, for commercial purposes, any users of the Site,
                including by transmitting any unsolicited or unauthorized
                advertising, promotional materials, junk mail, spam, chain
                letters, pyramid schemes or any other form of solicitation;
              </li>
              <li>
                impersonate anyone else or lie about your affiliation with
                another person or entity;
              </li>
              <li>
                use the Site to harm minors in any way, including posting User
                Content that violates child pornography laws, child sexual
                exploitation laws or any other laws protecting children;
              </li>
              <li>
                collect or gather other people’s personal information (including
                account information) from the Site; or
              </li>
              <li>use the Site for any other illegal purpose.</li>
              <li>
                We have the right, (but not necessarily the obligation), to
                delete or edit at any time any User Content that violates these
                rules or that we believe to be inappropriate for any reason.
              </li>
            </ul>
            <h2>6. Intellectual Property Rights in User Content</h2>
            <ul>
              <li>
                If you post User Content, you are making a guarantee to us that
                you either own all the User Content you are posting or you have
                the right to post the User Content.
              </li>
              <li>
                Furthermore, you are guaranteeing that you have the right to
                allow us to make your User Content available for others to view
                and use as part of the Site without requiring that any such use
                be subject to additional obligations or terms.
              </li>
              <li>
                If you do not have these rights, do not post your User Content.
                By posting your User Content, you do not lose any ownership
                rights you may have to it.
              </li>
              <li>
                However, you do grant us and each user of the Site a worldwide,
                non-exclusive, irrevocable, perpetual, fully-paid, sublicensable
                (through multiple tiers) and transferable license to use,
                reproduce, distribute, modify, prepare derivative works of,
                publicly display and perform and otherwise exploit your User
                Content, in any media formats or in tangible form and through
                any media channels now known or hereinafter developed. In
                addition, you waive any rights of publicity and privacy you have
                in posted User Content.
              </li>
            </ul>
            <h2>7. We Are Not Responsible for User Content</h2>
            <ul>
              <li>
                We generally do not monitor or review any User Content. We do
                not endorse any User Content or support any views, opinions,
                recommendations or advice that may be in User Content.
              </li>
              <li>
                User Content comes from a variety of sources, and we make no
                promises about the reliability of any source or the accuracy,
                usefulness, safety or intellectual property rights of any User
                Content.
              </li>
              <li>
                You may be offended by User Content that you see on the Site.
                You may find some of it to be inaccurate, indecent or
                objectionable. However, as further set forth below, you agree
                not to hold us responsible in any way for your use of the Site,
                including your exposure to User Content.
              </li>
              <li>
                In addition, we are not a content-archiving service. We do not
                promise to store or make available on the Site any User Content
                that you post, or any other Content, for any length of time. You
                are solely responsible for keeping back-ups of everything you
                post on the Site.
              </li>
            </ul>
            <h2>8. Proprietary Rights</h2>
            <ul>
              <li>
                The Site contains proprietary and confidential information that
                is protected by applicable intellectual property and other laws
                and Authcite Limited and its suppliers retain all right, title
                and interest (including all copyright, trade secret, patent and
                other rights) in and to the Site and Content which is included
                in the Site (other than User Content).
              </li>
              <li>
                If you give feedback on the Site, for example recommendations
                for improvements or features, we have the right to use the
                feedback in any way and implementation of that feedback is owned
                by us and may become part of the Site without compensation to
                you.
              </li>
              <li>
                We reserve all rights in and to the Site unless we expressly
                state otherwise. We also reserve the right to make changes or
                updates to the Site or Content provided on or through the Site
                at any time without notice and we will own any such changes or
                updates (excluding User Content).
              </li>
            </ul>
            <h4>You may not:</h4>
            <ul>
              <li>
                decompile, reverse engineer or disassemble any object code which
                is part of or made available through the Site into a
                human-perceivable form, except and only to the extent that such
                activity is expressly permitted by applicable law, and in that
                case, only if you notify us in writing in advance;
              </li>
              <li>
                copy, frameset, enclose or otherwise sell, distribute, transmit
                or broadcast any part of the Site;
              </li>
              <li>
                modify or create any derivative work of any part of the Site;
              </li>
              <li>
                disable, interfere or try to get around any of the features of
                the Site related to security, preventing or restricting use or
                copying of any Content or enforcing the limits on the use of the
                Site or the Content on the Site; or
              </li>
              <li>
                use, export or re-export any Content or any copy or adaptation
                of such Content in violation of any applicable laws or
                regulations, including, without limitation, United States export
                laws and regulations.
              </li>
              <li>
                All brand, product and service images, logos and names used in
                the Site that identify Authcite Limited or our suppliers and our
                or their proprietary products and services are the trademarks or
                service marks of Authcite Limited or our suppliers. Nothing in
                this Site will be deemed to confer on any person any license or
                right on the part of Authcite Limited or such supplier with
                respect to any such image, logo or name.
              </li>
            </ul>
            <h2>9. Enforcement of Copyrights</h2>
            <ul>
              <li>
                We respect the intellectual property rights of others. You may
                not use the Site to infringe anyone else’s copyright or other
                intellectual property right. If we find out that you are
                infringing, we may remove your User Content.
              </li>
              <li>
                We do not have to give you notice that we are removing your User
                Content. In addition to our other rights and remedies, we may
                also terminate your account if we determine that you are a
                repeat copyright infringer.
              </li>
              <li>
                We consider a repeat infringer to be a user who has been
                notified of infringing activity more than twice or who has had
                their User Content removed from the Site more than twice.
              </li>
            </ul>
            <h2>10. Notify Us of Infringers</h2>
            <ul>
              <li>
                If you believe that something on the Site violates your
                copyright, notify our copyright agent in writing. Please contact
                us as at hello@puplier.com
              </li>
              <li>
                In order for us to take action, your notice must include the
                following information consistent with the requirements of the
                Digital Millennium Copyright Act, 17 U.S.C. Section
                512(c)(3)(A):
              </li>
              <li>
                your full legal name and your electronic or physical signature;
              </li>
              <li>
                a description of the copyrighted work that you claim has been
                infringed;
              </li>
              <li>
                a description of where the material you claim is infringing is
                located, including the URL or the exact location where such
                material may be found;
              </li>
              <li>
                your company affiliation (if applicable), mailing address,
                telephone number and e-mail address;
              </li>
              <li>
                a statement by you that you have a good-faith belief that the
                disputed use is not authorized by the copyright owner, its
                agent, or the law; and
              </li>
              <li>
                a statement by you, made under penalty of perjury, that the
                above information in your notice is accurate and that you are
                the copyright owner or authorized to act on the copyright
                owner’s behalf.
              </li>
              <li>
                You may also use this same process to make a complaint about
                trademark infringement. Again, we cannot take action unless you
                give us all the required information.
              </li>
            </ul>
            <h2>11. How to Communicate with Us</h2>
            <ul>
              <li>
                Only notices about infringement should go to hello@puplier.com.
              </li>
              <li>
                If you have anything else to communicate with us (like feedback,
                comments or requests for technical support), you should contact
                us through the methods described – hello@puplier.com
              </li>
            </ul>
            <h2>12. Site Availability</h2>
            <ul>
              <li>
                You acknowledge that temporary interruptions in the availability
                of the Site may occur from time to time as normal events. Also,
                we may decide to cease making available the Site or any portion
                of the Site at any time and for any reason. Under no
                circumstances will Authcite Limited or its suppliers be held
                liable for any damages due to such interruptions or lack of
                availability.
              </li>
            </ul>
            <h2>13. Links to Other Sites</h2>
            <ul>
              <li>
                The Site may contain links to other websites that we don’t own
                or control. We are not responsible for and do not recommend or
                endorse these other websites, and we make no representations
                regarding their content or accuracy. You will not hold us
                responsible for any aspect of these other websites, including
                their content, privacy policies or anything else.
              </li>
            </ul>
            <h2>14. Warranty Disclaimer</h2>
            <p>
              Authcite Limited and the Authcite Limited entitles make no
              warranty that:
            </p>
            <ul>
              <li> puplier.com will meet your requirements</li>
              <li>
                The site will be uninterrupted, timely, secure or error-free
              </li>
              <li>
                Any content provided throughout the site is factually accurate
                or reliable
              </li>
              <li>
                Any material obtained through the use of the site is are
                obtained at your own discretion and risk
              </li>
              <li>
                Inio will not be responsible for any damages caused to your
                computer or data or any bugs, viruses, trojan horses, or
                destructive code resulting from the use of the site or content
                obtained from the site.
              </li>
            </ul>
            <h2>15. Limitation of Liability</h2>
            <ul>
              <li>
                To the fullest extent permitted under law, Authcite Limited
                entitles have no liability arising out of or related to these
                terms for any loss of use, loss data, lost profits, failure of
                security mechanisms, interruption of business or any indirect,
                incidental special, punitive reliance or consequential damages
                of any kind, even if we have been advised of their possibility
                in advance.
              </li>
              <li>
                Notwithstanding anything to the contrary contained herein,
                Authcite Limited’s (and the Authcite Limited entities), entire
                liability to you or any third parties under any circumstances
                relating your access to the site or other activities governed by
                these terms will not exceed in aggregate one hundred dollars (US
                $100).
              </li>
            </ul>
            <h2>16. Indemnity</h2>
            <ul>
              <li>
                You agree to indemnify, defend (if we so request) and hold
                harmless Authcite Limited and the Authcite Limited Entities from
                and against any claim, demand, losses, damages or expenses
                (including reasonable attorneys’ fees) arising from your User
                Content, your use of the Site, your connection to the Site, your
                violation of these Terms or your violation of any rights of any
                third party. Your indemnification obligation will survive the
                termination of these Terms and your use of the Site.
              </li>
            </ul>
            <h2>17. Termination and Suspension</h2>
            <ul>
              <li>
                We may terminate or suspend your permission to use the Site
                immediately and without notice upon any violation of these
                Terms, upon the request of law enforcement or government
                agencies, for extended periods of inactivity, for unexpected
                technical issues or problems or for engagement by you in
                fraudulent or illegal activities. If we terminate your use of
                the Site for any of these reasons or otherwise for cause, we
                will not refund any fees you may have paid for access to the
                Site. Upon any termination we may delete your account, passwords
                and User Content and we may bar you from further use of the
                Site. You understand that we may also continue to make your User
                Content available on the Site even if your use of the Site is
                terminated or suspended. You agree that we will have no
                liability to you or any third party for termination of your
                account, User Content or access to the Site.
              </li>
            </ul>
            <h2>18. General Terms</h2>
            <ul>
              <li>
                These Terms are governed by laws of the United Kingdom, without
                respect to its conflict of laws principles. The sole
                jurisdiction and venue for any claim arising from the Site and
                these Terms will be courts located in the United Kingdom and
                each party hereby consents to the exclusive jurisdiction and
                venue of such courts.
              </li>
              <li>
                These Terms, together with our Privacy Policy and any other
                notices or policies we have published on the Site (and
                additional terms for specific features or areas, as applicable),
                constitute the entire agreement between you and us regarding
                this Site.
              </li>
              <li>
                If a court having proper authority decides that any portion of
                these Terms is invalid, only the part that is invalid will not
                apply. The rest of these Terms will still be in effect. If we
                waive any of our rights under these Terms in any particular
                instance, it does not mean that we are waiving our rights
                generally or in the future. Furthermore, just because we may not
                enforce all our rights all of the time, it does not mean that we
                are waiving our rights. We may decide to enforce them at a later
                date.
              </li>
              <li>
                These Terms, and any rights and licenses granted under these
                Terms, may not be transferred or assigned by you except as
                expressly set forth herein, but may be assigned by us without
                restriction.
              </li>
              <li>
                We won’t be liable to you for any delay or failure to perform
                any obligation we have under these Terms if the delay or failure
                is due to events which are beyond our reasonable control,
                including but not limited to any strike, blockade, war, act of
                terrorism, riot, natural disaster, pandemic, failure or
                diminishment of power or of telecommunications or data networks
                or services or refusal of approval or a license by a government
                agency.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
